<template>
    <div>
        <b-sidebar
            v-model="open"
            title="Detalhes da Atividade"
            backdrop-variant="dark"
            width="390px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="task">
                <dl>
                    <dt>
                        Atividade
                    </dt>
                    <dd>
                        {{ task.name }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Corretor
                    </dt>
                    <dd>
                        <span v-if="task.teacher">
                            {{ task.teacher.name }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Turma
                    </dt>
                    <dd>
                        <span v-if="task.group">
                            {{ task.group.name }}
                        </span>
                        <span v-else>
                            ---
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Modo de Correção / Tema
                    </dt>
                    <dd>
                        <span v-if="task.theme">
                            <a :href="'/student/themes/' + task.theme.id" target="_blank">
                                {{ task.theme.title }}
                            </a>
                        </span>
                        <span v-else>
                            <span v-if="task.mode">
                                {{ task.mode.name }}
                            </span>
                            <span v-else>
                                ---
                            </span>
                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Data Início
                    </dt>
                    <dd>
                        {{ task.from | moment('DD/MM/YYYY HH:mm') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Data Fim
                    </dt>
                    <dd v-if="task.to">
                        {{ task.to | moment('DD/MM/YYYY HH:mm') }}
                    </dd>
                    <dd v-else>
                        ---
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Status
                    </dt>
                    <dd>
                        <span class="text-success" v-if="task.essays.length > 0">
                            Redação Enviada
                        </span>
                        <span v-else>

                            <span v-if="task.status === 'waiting'" class="text-info">
                                Aguardando Início
                            </span>

                            <span v-else-if="task.status === 'in_progress'" class="text-primary">
                                Em Andamento
                            </span>

                            <span v-else-if="task.status === 'finished'" class="text-danger">
                                Prazo Encerrado
                            </span>

                            <span v-else>
                                ---
                            </span>

                        </span>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Criada
                    </dt>
                    <dd>
                        {{ task.created_at | moment('from', 'now') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Última Modificação
                    </dt>
                    <dd>
                        {{ task.updated_at | moment('from', 'now') }}
                    </dd>
                </dl>

            </div>
        </b-sidebar>
    </div>
</template>

<script>

export default {
    props: [],
    data() {
        return {
            open: false,
            task: null
        }
    },
    created() {

        this.$root.$on('tasksShowDetail', (task) => {
            this.task = task
            this.open = true
        })

    },
    methods: {

        editTask() {
            window.location = '/student/tasks/' + this.task.id + '/edit'
        },

    }
}
</script>

<style scoped>

</style>
